import React, { useEffect, useState } from "react";
import * as styles from "./UxScoreButton.module.scss";
import { motion } from "framer-motion";
import { useDisclosure } from "@mantine/hooks";
import UxScoreForm from "../UxScoreForm/UxScoreForm";
import { usePageWrapperContext } from "../PageWrapper/PageWrapper";

function AnimatedLogo() {
  const [cycle, setCycle] = useState(0);

  const barHeights = [9, 18, 27];

  useEffect(() => {
    const interval = setInterval(() => {
      setCycle((prev) => prev + 1);
    }, 3200);

    return () => clearInterval(interval);
  }, []);

  const barAnimation = (i) => ({
    initial: { height: 0, opacity: 0.7 },
    animate: {
      height: [0, barHeights[i], barHeights[i], 0],
      opacity: [0.7, 1, 1, 0.7],
      transition: {
        duration: 3.2,
        times: [0, 0.1 + i * 0.15, 0.6, 0.9],
        ease: "easeInOut",
        repeat: Infinity,
      },
    },
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        height: "30px",
        gap: "3px",
      }}
    >
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          style={{
            width: "5px",
            background: "#e40a65",
            borderRadius: "3px",
            originY: "bottom",
          }}
          initial="initial"
          animate="animate"
          variants={barAnimation(i)}
          custom={cycle}
        />
      ))}
    </div>
  );
}

export default function UxScoreButton() {
  const [opened, { open, close }] = useDisclosure();
  const { changeModalState } = usePageWrapperContext();

  return (
    <>
      <button
        className={styles.UxScoreButton__toolsButton}
        onClick={() => {
          open();
          sessionStorage.setItem("formOpen", "true");
        }}
      >
        <span>
          <AnimatedLogo />
        </span>
        <span>
          GET YOUR <br /> FREE UX SCORE
        </span>
      </button>
      <UxScoreForm opened={opened} close={close} />
    </>
  );
}
